/* src/app/job-signoff/partials/job-signoff-manager/job-signoff-manager.component.scss */
/*# sourceMappingURL=job-signoff-manager.component.css.map */
